import React from "react";
import StudentForm from "./StudentForm";

function App() {
  return <StudentForm />;
}

export default App;